import { openBlock as t, createElementBlock as h, createStaticVNode as a } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, l = /* @__PURE__ */ a('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#0052B4" d="M20 40c11.046 0 20-8.954 20-20 0-2.446-.44-4.79-1.244-6.957H1.244A19.957 19.957 0 0 0 0 20c0 11.046 8.954 20 20 20Z"></path><path fill="#D80027" d="M20 40c8.6 0 15.93-5.428 18.756-13.044H1.244C4.07 34.572 11.4 40 20 40Z"></path><path fill="#F0F0F0" d="M5.172 11.304v9.977c0 5.676 7.414 7.415 7.414 7.415S20 26.956 20 21.28v-9.977H5.172Z"></path><path fill="#D80027" d="M6.91 11.304v9.977c0 .667.149 1.296.442 1.886H17.82c.293-.59.44-1.22.44-1.886v-9.977H6.91Z"></path><path fill="#F0F0F0" d="M16.064 18.26h-2.609v-1.738h1.74v-1.74h-1.74v-1.739h-1.739v1.74H9.977v1.739h1.74v1.739h-2.61V20h2.61v1.74h1.738V20h2.609v-1.74Z"></path><path fill="#0052B4" d="M9.724 25.595c1.12.704 2.272 1.113 2.862 1.295.59-.182 1.74-.591 2.861-1.296 1.13-.71 1.923-1.522 2.373-2.427a3.029 3.029 0 0 0-2.448-.478 3.044 3.044 0 0 0-5.572 0 3.046 3.046 0 0 0-2.448.478c.45.905 1.242 1.717 2.372 2.427Z"></path>', 7), e = [
  l
];
function o(p, i) {
  return t(), h("svg", c, [...e]);
}
const d = { render: o };
export {
  d as default,
  o as render
};
